import { useParams } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getMyStudents } from "wasp/client/operations";
import StudentLayout from "./StudentLayout";
import GlobalNotesTab from "./GlobalNotesTab";

export default function StudentOverviewPage() {
  const { studentId } = useParams<{ studentId: string }>();

  const { data: students = [], isLoading } = useQuery(getMyStudents);

  if (!studentId) return null;

  const student = students.find((s: any) => s.studentId === studentId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <p className="text-muted-foreground text-sm">Chargement...</p>
      </div>
    );
  }

  if (!student) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <p className="text-muted-foreground text-sm">Élève introuvable ou relation inactive.</p>
      </div>
    );
  }

  const permissions = student.permissions ?? {
    canViewJournal: false,
    canViewDashboard: false,
    canViewAnalytics: false,
    canViewSessions: false,
    canViewPropFirmManager: false,
  };

  return (
    <StudentLayout
      studentId={studentId}
      studentFirstName={student.student.firstName}
      studentLastName={student.student.lastName}
      studentEmail={student.student.email ?? undefined}
      permissions={permissions}
    >
      <div className="max-w-2xl">
        <GlobalNotesTab studentId={studentId} />
      </div>
    </StudentLayout>
  );
}
